import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useNavigate } from 'react-router-dom';



export default function BreadCrumbV2({ breadCrumbLinks }) {
  let navigate = useNavigate();

  return (
    <div role="presentation">
      <Breadcrumbs aria-label="breadcrumb" style={{ cursor: 'pointer' }}>
        {breadCrumbLinks.map((breadCrumbLink, index) => {
          return (
            <Link
              key={index}
              onClick={() => {
                if (index + 1 !== breadCrumbLinks.length) {
                  if (breadCrumbLink.link === '#') {
                    navigate(-1);
                  } else {
                    navigate(breadCrumbLink.link);
                  }
                }
              }}
            >
              {breadCrumbLink.name}
            </Link>
          );
        })}
      </Breadcrumbs>
    </div>
  );
}
